export const useBreakpoint = () => {
  const isMobile = ref(false);
  const isTable = ref(false);
  const isDesktop = ref(false);
  const isLargeMonitor = ref(false);

  const checkBreakpoint = () => {
    const width = window.innerWidth
    if (process.client) {
      isMobile.value = width < 640;
      isTable.value = width >= 640 && width < 768;
      isDesktop.value = width >= 768 && width < 1024;
      isLargeMonitor.value = width >= 1024;
    }
  };

  // Run on mount and when the window resizes
  // Remove listener on unmount
  if (process.client) {
    window.addEventListener('resize', checkBreakpoint);
    onMounted(checkBreakpoint);
    onBeforeUnmount(() => window.removeEventListener('resize', checkBreakpoint))
  }

  return {
    isMobile,
    isTable,
    isDesktop,
    isLargeMonitor
  }
}
